import {Routes} from '@angular/router';
import {BaseLayoutComponent} from "./features/shell/layouts/base-layout/base-layout.component";
import {AccountLayoutComponent} from "./layout/account-layout/account-layout.component";
import {ExportPagesLayoutComponent} from "./layout/export-pages-layout/export-pages-layout.component";

export const routes: Routes = [
  {
    path: 'auth', component: AccountLayoutComponent,
    loadChildren: () => import('./features/account/auth.routes').then(m => m.routes)
  },
  {
    path: 'account', component: AccountLayoutComponent,
    loadChildren: () => import('./features/account/account.routes').then(m => m.routes)
  },
  {
    path: 'export-pages', component: ExportPagesLayoutComponent,
        loadChildren: () => import('./features/export-pages/export-pages.routes').then(m => m.routes)
  },

  {
    path: 'debug-setting',
    pathMatch: 'full',
    loadComponent: () => import('./features/debug/debug-setting/debug-setting.component')
      .then((module) => module.DebugSettingComponent),
  },
  // fallback route
  {path: 'home', redirectTo: '/site/list'},
  {
    path: '', component: BaseLayoutComponent, children: [
      {
        path: 'site',
        loadChildren: () => import('./features/site-management/site.routes').then(m => m.routes)
      },
      {
        path: 'device',
        loadChildren: () => import('./features/device-management/device.routes').then(m => m.routes)
      },
      {
        path: 'device-group',
        loadChildren: () => import('./features/device-group/device-group.routes').then(m => m.routes)
      },
      {
        path: 'account-management',
        loadChildren: () => import('./features/account-management/account-management.routes').then(m => m.routes)
      },
      {
        path: 'isp',
        loadChildren: () => import('./features/isp-management/isp.routes').then(m => m.routes)
      },
      {
        path: 'system-status',
        loadChildren: () => import('./features/system-status/system-status.routes').then(m => m.routes)
      },
      {path: '**', redirectTo: '/site/list'}
    ]
  },
  {path: '**', redirectTo: '/site/list'}
];
